import { render, staticRenderFns } from "./HistoricoAcademico.vue?vue&type=template&id=b3d8b9bc&scoped=true&"
import script from "./HistoricoAcademico.vue?vue&type=script&lang=js&"
export * from "./HistoricoAcademico.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoAcademico.vue?vue&type=style&index=0&id=b3d8b9bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d8b9bc",
  null
  
)

export default component.exports